export enum VariantsTypes {
    MODIFY_GUESTS = 'MODIFY_GUESTS',
    PAYMENT = 'MAKE_PAYMENT',
    ADD_ONS = 'ADD_ONS',
    LATE_CHECKOUT = 'LATE_CHECKOUT',
    CANCEL = 'CANCEL',
    DEFAULT = '',
}

export interface LegacyOptions {
    id: string;
    title: string;
    url: string;
}

export enum LegacyRoutes {
    HOME = 'home',
    DRIVING_DIRECTIONS = 'driving-directions',
    LATE_CHECKOUT = 'late-checkout',
    MODIFY = 'modify',
    CANCEL = 'cancel',
    PARKING = 'parking',
    PAY_BALANCE = 'pay-balance',
    RECEIPT = 'receipt',
    REGISTER_VEHICLE = 'register-vehicle',
    SIGN_AGREEMENT = 'sign-agreement',
    EARLY_CHECKOUT = 'early-checkout',
}
